<template lang="html">

  <section class="wrapper">

    <div class="legal container">

      <h1>Política de cookies</h1>

      <p>
        ¿Qué son las cookies? Este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan
        información cuando navegas. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por
        ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación, o personalizar la forma
        en que se muestra el contenido. Los usos concretos que hacemos de estas tecnologías se describen a continuación.
      </p>
      <h2>
        ¿Qué tipo de cookies existen?
      </h2>
      <p>
        A manera enunciativa y no taxativa, las siguientes:
      </p>
      <ol>
        <li>
          1. Tipos de cookies según la entidad que la gestione:
          <ul>
            <li>
              a) Cookies propias: son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio
              gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.
            </li>
            <li>
              b) Cookies de tercero: son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio
              que
              no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies.
            </li>
          </ul>
        </li>
        <li>
          2. Tipos de cookies según su finalidad:
          <ul>
            <li>
              a) Cookies técnicas: son aquellas que permiten al usuario la navegación a través de una página web,
              plataforma o
              aplicación y la utilización de las diferentes opciones o servicios que en ella existan, incluyendo
              aquellas que
              el editor utiliza para permitir la gestión y operativa de la página web y habilitar sus funciones y
              servicios,
              como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a
              partes de
              acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un
              pedido,
              gestionar el pago, controlar el fraude vinculado a la seguridad del servicio, realizar la solicitud de
              inscripción o participación en un evento, contar visitas a efectos de la facturación de licencias del
              software
              con el que funciona el servicio (sitio web, plataforma o aplicación), utilizar elementos de seguridad
              durante la
              navegación, almacenar contenidos para la difusión de vídeos o sonido, habilitar contenidos dinámicos (por
              ejemplo, animación de carga de un texto o imagen) o compartir contenidos a través de redes sociales.
              También
              pertenecen a esta categoría, por su naturaleza técnica, aquellas cookies que permiten la gestión, de la
              forma
              más eficaz posible, de los espacios publicitarios que, como un elemento más de diseño o “maquetación” del
              servicio ofrecido al usuario, el editor haya incluido en una página web, aplicación o plataforma en base a
              criterios como el contenido editado, sin que se recopile información de los usuarios con fines distintos,
              como
              puede ser personalizar ese contenido publicitario u otros contenidos.
            </li>
            <li>
              b) Cookies de preferencias o personalización: son aquellas que permiten recordar información para que el
              usuario
              acceda al servicio con determinadas características que pueden diferenciar su experiencia de la de otros
              usuarios, como, por ejemplo, el idioma, el número de resultados a mostrar cuando el usuario realiza una
              búsqueda, el aspecto o contenido del servicio en función del tipo de navegador a través del cual el
              usuario
              accede al servicio o de la región desde la que accede al servicio, etc.
            </li>
            <li>
              c) Cookies de análisis o medición: son aquellas que permiten al responsable de las mismas el seguimiento y
              análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la
              cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se
              utiliza
              en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir
              mejoras en
              función del análisis de los datos de uso que hacen los usuarios del servicio.
            </li>
            <li>
              d) Cookies de publicidad comportamental: son aquellas que almacenan información del comportamiento de los
              usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite
              desarrollar
              un perfil específico para mostrar publicidad en función del mismo.
            </li>
          </ul>
        </li>
        <li>
          3. Tipos de cookies según el plazo de tiempo que permanecen activadas:
          <ul>
            <li>
              a) Cookies de sesión: son aquellas diseñadas para recabar y almacenar datos mientras el usuario accede a
              una
              página web. Se suelen emplear para almacenar información que solo interesa conservar para la prestación
              del
              servicio solicitado por el usuario en una sola ocasión (por ejemplo, una lista de productos adquiridos) y
              desaparecen al terminar la sesión.
            </li>
            <li>
              b) Cookies persistentes: son aquellas en las que los datos siguen almacenados en el terminal y pueden ser
              accedidos y tratados durante un periodo definido por el responsable de la cookie, y que puede ir de unos
              minutos
              a varios años.
            </li>
          </ul>
        </li>
      </ol>

      <h2>
        ¿Qué tipo de cookies se utilizan en esta página web?
      </h2>

      <div class="contenedor-tabla">
        <table>
          <thead>
            <tr>
              <td>Nombre de la cookie</td>
              <td>Editor</td>
              <td>Nombre editor</td>
              <td>Finalidad</td>
              <td>Descripción finalidad</td>
              <td>Tiempo que permanecen activas</td>
              <td>Transferencias internacionales</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>cookieyesID</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>Identificador único para visitantes utilizado por CookieYes con respecto al consentimiento
              </td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>cky-consent</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>CookieYes establece la cookie para recordar el consentimiento del usuario para el uso de cookies en el sitio web.</td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>cookieyes-necessary</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>CookieYes establece esta cookie y se utiliza para recordar el consentimiento de los usuarios para el uso de cookies necesarias.
              </td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>cookieyes-functional</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>CookieYes establece esta cookie y se utiliza para recordar el consentimiento de los usuarios para el uso de cookies funcionales
              </td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>cookieyes-analytics</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>CookieYes establece esta cookie y se utiliza para recordar el consentimiento de los usuarios para el uso de cookies analíticas
              </td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>cookieyes-performance</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>CookieYes establece esta cookie y se utiliza para recordar el consentimiento de los usuarios para el uso de cookies de "Rendimiento".
              </td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>cookieyes-advertisement</td>
              <td>Cookie de terceros</td>
              <td><a href="https://www.cookieyes.com/privacy-policy/" target="_blank">Cookie Yes</a></td>
              <td>Técnicas o necesarias</td>
              <td>CookieYes establece esta cookie y se utiliza para recordar el consentimiento de los usuarios para el uso de cookies de publicidad comportamental
              </td>
              <td>1 año</td>
              <td>País de destino: United Kingdom
              </td>
            </tr>
            <tr>
              <td>_ga</td>
              <td>Cookie de terceros</td>
              <td><a href="https://policies.google.com/technologies/types?hl=es" target="_blank">Google</a> 
              </td>
              <td>Analíticas
              </td>
              <td>Google Analytics instala esta cookie. La cookie se utiliza para calcular los datos de visitantes, sesiones y campañas y realizar un seguimiento del uso del sitio para el informe de análisis del sitio. Las cookies almacenan información de forma anónima y asignan un número generado aleatoriamente para identificar visitantes únicos.
              </td>
              <td>2 años</td>
              <td>País de destino: EEUU
              </td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>Cookie de terceros</td>
              <td><a href="https://policies.google.com/technologies/types?hl=es" target="_blank">Google</a> 
              </td>
              <td>Analíticas
              </td>
              <td>Google Analytics instala esta cookie. La cookie se utiliza para almacenar información sobre cómo los visitantes usan un sitio web y ayuda a crear un informe analítico de cómo está funcionando el sitio web. Los datos recopilados, incluido el número de visitantes, la fuente de donde provienen y las páginas, se muestran de forma anónima.
              </td>
              <td>1 día</td>
              <td>País de destino: EEUU
              </td>
            </tr>
            <tr>
              <td>_gat_UA-87588846_1</td>
              <td>Cookie de terceros</td>
              <td><a href="https://policies.google.com/technologies/types?hl=es" target="_blank">Google</a> 
              </td>
              <td>De rendimiento
              </td>
              <td>Google Analytics instala esta cookie. La cookie se utiliza para almacenar información sobre cómo los visitantes usan un sitio web y ayuda a crear un informe analítico de cómo está funcionando el sitio web. Los datos recopilados, incluido el número de visitantes, la fuente de donde provienen y las páginas, se muestran de forma anónima.
              </td>
              <td>1 minuto</td>
              <td>País de destino: EEUU
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>Transferencias internacionales de cookies de terceros</h3>

      <p>Puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas (ver los enlaces facilitados en el apartado “Nombre del Editor”).</p>


      <h3>
        Licitud del tratamiento
      </h3>
      <p>
        La base legal del tratamiento es su consentimiento (libre, específico, informado e inequívoco). Podrá revocar su
        consentimiento, siga las instrucciones del siguiente apartado.
      </p>
      <h3>
        Forma de aceptar, denegar, revocar el consentimiento o eliminar las cookies
      </h3>
      <p>
        Puede permitir o bloquear las cookies accediendo al configurador de las cookies previamente señalado.
      </p>
      <p>
        En el caso de que nuestro sistema de gestión o configuración de las cookies no permitiese evitar la utilización
        de las cookies de terceros una vez aceptadas por el usuario, puede usted permitir o bloquear las cookies, así
        como borrar sus datos de navegación (incluidas las cookies) desde el navegador que usted utiliza o desde las
        opciones de configuración del tercero accediendo a través del link facilitado previamente. Consulte las opciones
        e instrucciones que ofrece su navegador para ello.
      </p>
      <ul>
        <li>
          <a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-#w_configurar-las-cookies">Firefox</a>
        </li>
        <li>
          <a href="https://support.google.com/chrome/answer/95647?hl=es">Chrome</a>
        </li>
        <li>
          <a href="https://support.microsoft.com/es-es/topic/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d">Explorer</a>
          
        </li>
        <li>
          <a href="https://support.apple.com/es-es/HT201265">Safari</a>
        </li>
        <li>
          Otros navegadores: consulte la documentación del navegador que tenga instalado.
        </li>
      </ul>
      <h3>
        Elaboración de perfiles automatizada con efectos jurídicos
      </h3>
      <p>
        Las cookies instaladas si bien realizan análisis de perfiles de forma automatizada, no produce efectos
        jurídicos.
      </p>

      <h3>
        Otra información exigida por el art. 13 del RGPD
      </h3>
      <p>
        Formando parte del deber de información exigido por el art. 13 del RGPD, os remitimos a la Política de
        privacidad https://www.ufv.es/politica-de-privacidad/ para informarle de:
      </p>
      <ul>
        <li>
          a) la identidad y los datos de contacto del responsable y, en su caso, de su representante;
        </li>
        <li>
          b) los datos de contacto del delegado de protección de datos, en su caso;
        </li>
        <li>
          c) la existencia del derecho a solicitar al responsable del tratamiento el acceso a los datos personales relativos
          al interesado, y su rectificación o supresión, o la limitación de su tratamiento, o a oponerse al tratamiento, así
          como el derecho a la portabilidad de los datos;
        </li>
        <li>
          d) el derecho a presentar una reclamación ante una autoridad de control;
        </li>
      </ul>

    </div>

  </section>

</template>

<script lang="js">
  export default {
    name: 'politica-de-cookies',
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue